import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["lines", "lineHeight", "truncate"];
import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
import { useTheme } from '../useTheme';
import { jsx as _jsx } from "react/jsx-runtime";
const replacePx = value => parseFloat(value.replace('px', ''));
export const StyledTruncate = styled(LayoutBox).withConfig({
  displayName: "TruncateLines__StyledTruncate",
  componentId: "hchh0g-0"
})(["-webkit-box-orient:vertical;-webkit-line-clamp:", ";display:-webkit-box;line-height:", ";max-block-size:", ";overflow:hidden;text-overflow:ellipsis;"], ({
  $lines
}) => $lines, ({
  $lineHeight
}) => $lineHeight, ({
  $lines,
  $lineHeight
}) => `calc(${$lines} * ${$lineHeight}em)`);
export const TruncateLines = _ref => {
  let {
      lines = 3,
      lineHeight,
      truncate = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    typography
  } = useTheme();
  if (!truncate) {
    return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest));
  }
  const baseFont = typography['body-100'];
  const baseFontSize = replacePx(baseFont.fontSize);
  const baseLineHeight = replacePx(baseFont.lineHeight);
  const defaultLineHeight = lineHeight || baseLineHeight / baseFontSize;
  return /*#__PURE__*/_jsx(StyledTruncate, Object.assign({}, rest, {
    $lineHeight: defaultLineHeight,
    $lines: lines
  }));
};